module.exports = __webpack_public_path__ + "static/img/ichat_phone3.15b8480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/ichat_phone3.jpg
// module id = 119
// module chunks = 0